import { StrictMode, lazy, Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter, Link, Route, Routes } from 'react-router';
import { RequerSessao } from './lib/sessao';
import { Marca } from './componentes/Marca';
import './estilos/tokens.css';
import './estilos/base.css';
import './estilos/paginas.css';

const Entrar = lazy(() => import('./rotas/Entrar'));
const Sessao = lazy(() => import('./rotas/Sessao'));
const Lista = lazy(() => import('./rotas/Lista'));
const Leitura = lazy(() => import('./rotas/Leitura'));
const Redacao = lazy(() => import('./rotas/Redacao'));

const queryClient = new QueryClient({
  defaultOptions: { queries: { staleTime: 30_000, retry: 1, refetchOnWindowFocus: false } },
});

function Carregando() {
  return <main className="conteudo"><p className="legenda" role="status">Carregando…</p></main>;
}

function NaoEncontrada() {
  return (
    <main className="conteudo entrar">
      <div className="estado">
        <span className="marca-app"><Marca /><span className="marca-app__produto">Caixa</span></span>
        <h1 className="titulo-s">Não achamos esta página.</h1>
        <p className="corpo">O endereço não existe neste cliente. Volte para a caixa.</p>
        <div className="estado__acoes">
          <Link className="botao botao--primario" to="/">Ir para a caixa</Link>
        </div>
      </div>
    </main>
  );
}

const g = globalThis as unknown as { __caixaRaiz?: ReturnType<typeof createRoot> };
g.__caixaRaiz ??= createRoot(document.getElementById('raiz')!);
g.__caixaRaiz.render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <Suspense fallback={<Carregando />}>
          <Routes>
            <Route path="/entrar" element={<Entrar />} />
            <Route path="/auth/sessao" element={<Sessao />} />
            <Route path="/" element={<RequerSessao><Lista /></RequerSessao>} />
            <Route path="/c/:mailboxId" element={<RequerSessao><Lista /></RequerSessao>} />
            <Route path="/c/:mailboxId/m/:messageId" element={<RequerSessao><Leitura /></RequerSessao>} />
            <Route path="/c/:mailboxId/nova" element={<RequerSessao><Redacao /></RequerSessao>} />
            <Route path="*" element={<NaoEncontrada />} />
          </Routes>
        </Suspense>
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
);
